import { render, staticRenderFns } from "./LocalsView.vue?vue&type=template&id=3b53ea3c&"
import script from "./LocalsView.vue?vue&type=script&lang=js&"
export * from "./LocalsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports